export default {
    key: 'hotel',
    type: 'Accommodation',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: true,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-hotel-steps-twocol-step-1-date',
            name: 'offerFlow.accommodation.steps.step1',
        },
        {
            routeName: 'offerFlow-hotel-steps-twocol-step-2-passengers',
            name: 'offerFlow.accommodation.steps.step2',
            skipIfUpsell: true,
        },
        {
            routeName: 'offerFlow-hotel-steps-twocol-step-3-residents',
            name: 'offerFlow.accommodation.steps.step3',
        },
        {
            routeName: 'offerFlow-hotel-steps-step-4-accommodation-list',
            name: 'offerFlow.accommodation.steps.step4',
            // hideInStepper: true,
        },
        {
            routeName: 'offerFlow-hotel-steps-step-5-accommodation-details',
            name: 'offerFlow.accommodation.steps.step5',
            // hideInStepper: true,
        },
    ],
} satisfies ProductConfigAccommodation;
